// src/Pages/Landing/JoyrideHameenlinnaLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideHameenlinnaLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Hämeenlinna"
      maakunta="Kanta-Häme"
      nearbyAreas={[
        "Riihimäki",
        "Janakkala",
        "Hattula",
        "Forssa",
        "Loppi",
        "Tammela"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Hämeenlinnassa ja Kanta-Hämeen alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Hämeenlinna sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Hämeenlinnan keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}